import { addRoomsToCartItemsAtom as l, removeRoomFromCartItemsAtom as u } from "./index34.mjs";
import { searchCriteriaAtom as A } from "./index26.mjs";
import { createNewCartItems as R } from "./index148.mjs";
import { useSetAtom as e, useAtomValue as v } from "jotai";
const g = () => {
  const m = e(l), a = e(u), s = v(A), d = (o, r, t) => {
    const { arrivalDate: c, departureDate: i, totalAdults: C, totalChildren: n } = s, p = R(
      o,
      r,
      t,
      c,
      i,
      C,
      n
    );
    m(p);
  };
  return {
    addOrRemoveFromCart: (o, r, t) => {
      o > 0 ? d(o, r, t) : a(
        r.roomId,
        t.pricingTypeId,
        t.promotionId
      );
    }
  };
};
export {
  g as useCartManager
};
